import { FC, useState } from "react";
import { Box, Heading, Skeleton, Stack, Text } from "@chakra-ui/react";

import FavoriteButton from "components/FavoriteButton/FavoriteButton";
import { useTracking } from "contexts/Tracking";
import { useDetailState } from "scenes/OfferDetail";
import { IMarginProps } from "src/types/types";
import { getLocationString } from "utils/offer";

const Perex: FC<IMarginProps> = (props) => {
  const { offer, isLoaded } = useDetailState();
  const [, setLoaded] = useState(false);

  const { trackEvent } = useTracking();

  return (
    <Stack
      direction="row"
      spacing="4px"
      onClick={() => setLoaded(!isLoaded)}
      {...props}
      data-test="offerDetail.perex"
    >
      <Stack flex="1" spacing="4px">
        <Skeleton minH="18px" noOfLines={2} isLoaded={isLoaded}>
          {offer && (
            <Text data-test="offerDetail.perex.location">
              {getLocationString({
                village: offer.village?.id
                  ? {
                      id: offer.village?.id,
                      title: offer.village?.name,
                    }
                  : null,
                villagePart: offer.villagePart?.id
                  ? {
                      id: offer.villagePart.id,
                      title: offer.villagePart.name,
                    }
                  : null,
                street: offer.street?.id
                  ? {
                      id: offer.street.id,
                      title: offer.street.name,
                    }
                  : null,
              })}
            </Text>
          )}
        </Skeleton>

        <Skeleton minH="30px" maxW="300px" noOfLines={3} isLoaded={isLoaded}>
          <Heading
            variant="h3"
            as="h1"
            textAlign="left"
            lineHeight="30px"
            color="ud-primary"
            data-test="offerDetail.perex.title"
          >
            {offer?.title}
          </Heading>
        </Skeleton>
      </Stack>

      <Box minW={["18px", null, "90px"]} textAlign="right">
        <Skeleton
          height="20px"
          display="inline-block"
          minW={["18px", 0, "70px"]}
          isLoaded={isLoaded}
        >
          {offer && (
            <FavoriteButton
              offerId={offer?.id}
              loginEvent={{
                LOGIN: {
                  "dl.eAct": "login",
                  "dl.eLab": "Uložit inzerát – detail inzerátu",
                  "dl.eCat": "",
                },
                REGISTRATION: {
                  "dl.eAct": "registration",
                  "dl.eLab": "Uložit inzerát – detail inzerátu",
                  "dl.eCat": "",
                },
              }}
              onRemove={() => {
                trackEvent({
                  "dl.eCat": "offer_detail",
                  "dl.eAct": "favs.clicked",
                  "dl.eLab": "Odebrat",
                });
              }}
              onAdd={() => {
                trackEvent({
                  "dl.eCat": "offer_detail",
                  "dl.eAct": "favs.clicked",
                  "dl.eLab": "Uložit",
                });
              }}
            />
          )}
        </Skeleton>
      </Box>
    </Stack>
  );
};

export default Perex;
